import { AllergenContainsEnum } from 'generated/graphql-gateway';

export type AllergensType = 'allergens' | 'maybeAllergens' | 'maybeCookedOnAllergens';

// List of allergen disclaimer message IDs. With 3 allergen group types, we have
// 2^3 possible combinations:
// [{}, {1}, {2}, {3}, {1, 2}, {1, 3}, {2, 3}, {1, 2, 3}]
type DisclaimerId =
  | 'allergensDisclaimerUnknown' // 000
  | 'allergensDisclaimerContains' // 001
  | 'allergensDisclaimerMayContain' // 010
  | 'allergensDisclaimerMayBeCookedOn' // 100
  | 'allergensDisclaimerMayContainAndMayBeCookedOn' // 110
  | 'allergensDisclaimerContainsAndMayBeCookedOn' // 101
  | 'allergensDisclaimerContainsAndMayContain' // 011
  | 'allergensDisclaimerContainsAndMayContainAndMayBeCooked'; // 111

// Mapping from a combination of allergen groups to the message ID to be used for
// localizable strings.
export const COMBINATION_TO_DISCLAIMER_ID: { [k: string]: DisclaimerId } = {
  '000': 'allergensDisclaimerUnknown',
  '001': 'allergensDisclaimerContains',
  '010': 'allergensDisclaimerMayContain',
  '100': 'allergensDisclaimerMayBeCookedOn',
  '110': 'allergensDisclaimerMayContainAndMayBeCookedOn',
  '101': 'allergensDisclaimerContainsAndMayBeCookedOn',
  '011': 'allergensDisclaimerContainsAndMayContain',
  '111': 'allergensDisclaimerContainsAndMayContainAndMayBeCooked',
};

export const ALLERGEN_GROUP_TYPE_TO_PARAM_ID: {
  [key in AllergenContainsEnum]: AllergensType | null;
} = {
  _3: 'allergens',
  _2: 'maybeAllergens',
  _1: 'maybeCookedOnAllergens',
  _0: null,
};

export const ALLERGEN_CONTAINS_ENUM_TO_NUMBER: {
  [key in AllergenContainsEnum]: number;
} = {
  _3: 3,
  _2: 2,
  _1: 1,
  _0: 0,
};

// This is the type for the ingredients for the item
// it is used to display the ingredients for the item
// for sanity and 1M items
export type IngredientsType = {
  name?: string;
  ingredients?: string[];
  image?: string;
};
